/*
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
*/

export default class Projections {
    constructor() {
        this.projections = [];
        this.siteCalibrations = []
        this.customerProjections = [];
        this.defaultProjectionId = 0;

    }

    setProjections(projections) {
        this.projections = [];
        this.siteCalibrations = [];
        projections.forEach(projection => {
            if (projection.projectId) {
                this.siteCalibrations.push(projection)
            } else {
                this.projections.push(projection)
            }

        });
    }

    addProjection(projection) {
        if (projection.projectId) {
            this.siteCalibrations.push(projection)
        } else {
            this.projections.push(projection)
        }
    }

    setCustomerProjections(projections) {
        this.customerProjections = projections;
    }

    setDefaultProjectionId(id) {
        this.defaultProjectionId = id;
    }

    get all() {
        return this.projections;
    }

    get withSiteCal() {
        return [...this.projections, ...this.siteCalibrations]
    }

    get customer() {
        return this.customerProjections;
    }

    get default() {
        if (this.customerProjections.length == 1) {
            return this.customerProjections[0];
        }
        return this.customerProjections?.find(p => p.projectionId == this.defaultProjectionId);
    }

    getByCode(code) {
        if (this.projections != null) {
            var projectionIndex = this.withSiteCal.findIndex((projection) => projection.code == code);
            if (projectionIndex != -1)
                return this.withSiteCal[projectionIndex];
        }

        return code;
    }
}